var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.showQuantity && _vm.useLargeScale && _vm.canBeAddedToBasket
      ? _c(
          "div",
          {
            directives: [{ name: "tooltip", rawName: "v-tooltip" }],
            staticClass: "category-item__add-to-basket",
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              title: "In die Naschtüte"
            }
          },
          [
            _c(
              "button",
              { staticClass: "btn btn-primary btn-block article-card__btn" },
              [_vm._v("In die Naschtüte")]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.showQuantity && _vm.useLargeScale && !_vm.canBeAddedToBasket
      ? _c(
          "div",
          {
            directives: [{ name: "tooltip", rawName: "v-tooltip" }],
            staticClass: "category-item__add-to-basket",
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              title: _vm.$translate("Ceres::Template.itemShowItem")
            }
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-primary btn-block article-card__btn article-card__btn--show",
                on: {
                  click: function($event) {
                    return _vm.goToItem($event.target)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$translate("Ceres::Template.itemShowItem")))]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showQuantity && !_vm.useLargeScale
      ? _c("div", { staticClass: "category-list-view-port" }, [
          _c("span", [
            _c(
              "div",
              { class: { "col-12 col-md-12 col-lg-12 my-3": !_vm.onlyQty } },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "add-to-basket-container d-flex justify-content-between"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "quantity-input-container" },
                      [
                        _c("quantity-input", {
                          attrs: {
                            value: _vm.quantity,
                            timeout: 0,
                            min: _vm.minimumQuantity,
                            max: _vm.maximumQuantity,
                            interval: _vm.intervalQuantity,
                            "variation-id": _vm.variationId,
                            waiting:
                              _vm.isLoading ||
                              !_vm.isSalable ||
                              !_vm.allVariationsSelected
                          },
                          on: {
                            "quantity-change": _vm.updateQuantity,
                            "out-of-stock": _vm.handleButtonState
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.allVariationsSelected
                      ? _c(
                          "button",
                          {
                            directives: [
                              { name: "tooltip", rawName: "v-tooltip" }
                            ],
                            staticClass:
                              "btn btn-block btn-primary disabled article-card__btn",
                            attrs: {
                              "data-toggle": "tooltip",
                              "data-placement": "top",
                              title: _vm.$translate(
                                "Ceres::Template.singleItemPleaseSelectValidVariation"
                              )
                            }
                          },
                          [
                            _vm._v(
                              "\n                        In die Naschtüte\n                    "
                            )
                          ]
                        )
                      : !_vm.buttonLockState
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-block btn-primary article-card__btn",
                            attrs: { disabled: _vm.isLoading || !_vm.hasPrice },
                            on: {
                              click: function($event) {
                                return _vm.addToBasket()
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-none d-md-flex d-xl-none justify-content-center align-items-center"
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "18",
                                      height: "25",
                                      viewBox: "0 0 35 42",
                                      version: "1.1",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink"
                                    }
                                  },
                                  [
                                    _c("defs"),
                                    _vm._v(" "),
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "header/header-xl",
                                          stroke: "none",
                                          "stroke-width": "1",
                                          fill: "none",
                                          "fill-rule": "evenodd",
                                          transform:
                                            "translate(-1608.000000, -84.000000)"
                                        }
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "header-lg",
                                              fill: "#FFFFFF"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id: "head",
                                                  transform:
                                                    "translate(0.000000, 45.000000)"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id: "basket",
                                                      transform:
                                                        "translate(1597.000000, 22.000000)"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          id: "basket-full",
                                                          transform:
                                                            "translate(0.250000, 0.296875)"
                                                        }
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d:
                                                              "M43.3893,57.0679 C43.3643,57.0959 43.3233,57.1309 43.2533,57.1309 L12.6013,57.1309 C12.5323,57.1309 12.4903,57.0959 12.4663,57.0679 C12.4453,57.0439 12.4253,57.0089 12.4213,56.9569 L14.2623,51.1149 L14.4113,20.4349 L15.1233,21.1469 L17.2593,19.0109 L19.3923,21.1469 L21.5243,19.0109 L23.6603,21.1469 L25.7933,19.0109 L27.9293,21.1469 L30.0623,19.0109 L32.1943,21.1469 L34.3303,19.0109 L36.4633,21.1469 L38.5993,19.0109 L40.7323,21.1469 L41.4443,20.4349 L41.5313,51.1079 L43.4343,56.9609 C43.4313,57.0089 43.4103,57.0439 43.3893,57.0679 M44.8373,56.7139 C44.9073,57.1749 44.7743,57.6409 44.4693,57.9959 C44.1633,58.3499 43.7223,58.5509 43.2533,58.5509 L12.6013,58.5509 C12.1363,58.5509 11.6913,58.3499 11.3893,57.9959 C11.0843,57.6409 10.9483,57.1719 11.0183,56.7139 L11.0423,56.6029 L13.0153,50.3399 L12.9903,48.4129 L12.9903,16.9999 L15.1233,19.1319 L17.2593,16.9999 L19.3923,19.1319 L21.5283,16.9999 L23.6603,19.1319 L25.7933,16.9999 L27.9293,19.1319 L30.0623,16.9999 L32.1983,19.1319 L34.3303,16.9999 L36.4633,19.1319 L38.5993,16.9999 L40.7323,19.1319 L42.8683,16.9999 L42.8683,49.0339 L42.7773,50.3439 L44.8373,56.7139 Z M33.6193,27.9653 C33.2263,27.9653 32.9073,28.2803 32.9073,28.6773 L32.9073,32.9423 C32.9073,35.6893 30.6733,37.9233 27.9293,37.9233 C25.1813,37.9233 22.9493,35.6893 22.9493,32.9423 L22.9493,28.6773 C22.9493,28.2803 22.6293,27.9653 22.2373,27.9653 C21.8443,27.9653 21.5243,28.2803 21.5243,28.6773 L21.5243,32.9423 C21.5243,36.4743 24.3963,39.3473 27.9293,39.3473 C31.4583,39.3473 34.3303,36.4743 34.3303,32.9423 L34.3303,28.6773 C34.3303,28.2803 34.0113,27.9653 33.6193,27.9653 Z M35.7511,29.3853 C36.1471,29.3853 36.4631,29.0703 36.4631,28.6773 C36.4631,27.1073 35.1891,25.8283 33.6191,25.8283 C32.0491,25.8283 30.7731,27.1073 30.7731,28.6773 C30.7731,29.0703 31.0901,29.3853 31.4861,29.3853 C31.8781,29.3853 32.1941,29.0703 32.1941,28.6773 C32.1941,27.8923 32.8341,27.2533 33.6191,27.2533 C34.4031,27.2533 35.0431,27.8923 35.0431,28.6773 C35.0431,29.0703 35.3591,29.3853 35.7511,29.3853 Z M22.237,27.2534 C23.022,27.2534 23.66,27.8924 23.66,28.6774 C23.66,29.0694 23.977,29.3854 24.373,29.3854 C24.765,29.3854 25.081,29.0694 25.081,28.6774 C25.081,27.1074 23.806,25.8284 22.237,25.8284 C20.667,25.8284 19.392,27.1074 19.392,28.6774 C19.392,29.0694 19.712,29.3854 20.104,29.3854 C20.497,29.3854 20.816,29.0694 20.816,28.6774 C20.816,27.8924 21.452,27.2534 22.237,27.2534 Z",
                                                            id: "Fill-7"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(
                                  "\n\n                      +\n                      "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "d-md-none d-xl-block" },
                              [
                                _vm._v(
                                  "\n                        In die Naschtüte\n                      "
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "button",
                          {
                            directives: [
                              { name: "tooltip", rawName: "v-tooltip" }
                            ],
                            staticClass:
                              "btn btn-block btn-primary disabled article-card__btn",
                            attrs: {
                              "data-toggle": "tooltip",
                              "data-placement": "top",
                              title: _vm._f(
                                "translate"
                              )("Ceres::Template.singleItemQuantityMax", {
                                max: _vm.item.variation.maximumOrderQuantity
                              })
                            }
                          },
                          [
                            _c("i", {
                              directives: [
                                {
                                  name: "waiting-animation",
                                  rawName: "v-waiting-animation",
                                  value: _vm.isLoading,
                                  expression: "isLoading"
                                }
                              ],
                              staticClass: "fa fa-shopping-cart",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(
                              "\n                        In die Naschtüte\n                    "
                            )
                          ]
                        )
                  ]
                )
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.showQuantity && !_vm.useLargeScale && !_vm.isWishList
      ? _c("div", { staticClass: "category-list-view-port" }, [
          _c(
            "div",
            {
              staticClass: "btn-group",
              attrs: { role: "group", "aria-label": "Thumb Control" }
            },
            [
              _vm.canBeAddedToBasket
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-outline-primary mobile-width-button",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.addToBasket()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-cart-plus fa-lg mobile-icon-right",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mobile-text-only" }, [
                        _vm._v("In die Naschtüte")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.canBeAddedToBasket
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-outline-primary mobile-width-button",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.directToItem()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fa fa-arrow-right fa-lg mobile-icon-right",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mobile-text-only" }, [
                        _vm._v(
                          _vm._s(_vm.$translate("Ceres::Template.itemShowItem"))
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.showQuantity && !_vm.useLargeScale && _vm.isWishList
      ? _c("div", { staticClass: "category-list-view-port" }, [
          _c(
            "div",
            {
              staticClass: "btn-group",
              attrs: { role: "group", "aria-label": "Thumb Control" }
            },
            [
              _vm.canBeAddedToBasket
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary mobile-width-button",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.addToBasket()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-cart-plus fa-lg mobile-icon-right",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mobile-text-only" }, [
                        _vm._v("In die Naschtüte")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.canBeAddedToBasket
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary mobile-width-button",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.directToItem()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fa fa-arrow-right fa-lg mobile-icon-right",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mobile-text-only" }, [
                        _vm._v(
                          _vm._s(_vm.$translate("Ceres::Template.itemShowItem"))
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }